var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 0C4.3125 0 3.75 0.5625 3.75 1.25V18.75C3.75 19.4375 4.3125 20 5 20H17.5C18.1875 20 18.75 19.4375 18.75 18.75V5L13.75 0H5Z",
    fill: "#E2E5E7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 5H18.75L13.75 0V3.75C13.75 4.4375 14.3125 5 15 5Z",
    fill: "#B0B7BD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 8.75L15 5H18.75V8.75Z",
    fill: "#CAD1D8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.25 16.25C16.25 16.5938 15.9688 16.875 15.625 16.875H1.875C1.53125 16.875 1.25 16.5938 1.25 16.25V10C1.25 9.65625 1.53125 9.375 1.875 9.375H15.625C15.9688 9.375 16.25 9.65625 16.25 10V16.25Z",
    fill: "#F15642"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.97412 11.845C3.97412 11.68 4.10412 11.5 4.3135 11.5H5.46787C6.11787 11.5 6.70287 11.935 6.70287 12.7687C6.70287 13.5587 6.11787 13.9987 5.46787 13.9987H4.6335V14.6587C4.6335 14.8787 4.4935 15.0031 4.3135 15.0031C4.1485 15.0031 3.97412 14.8787 3.97412 14.6587V11.845ZM4.6335 12.1294V13.3744H5.46787C5.80287 13.3744 6.06787 13.0787 6.06787 12.7687C6.06787 12.4194 5.80287 12.1294 5.46787 12.1294H4.6335Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.68143 15.005C7.51643 15.005 7.33643 14.915 7.33643 14.6956V11.8569C7.33643 11.6775 7.51643 11.5469 7.68143 11.5469H8.8258C11.1095 11.5469 11.0595 15.005 8.8708 15.005H7.68143ZM7.99642 12.1569V14.3956H8.8258C10.1752 14.3956 10.2352 12.1569 8.8258 12.1569H7.99642Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8701 12.1975V12.9919H13.1444C13.3244 12.9919 13.5044 13.1719 13.5044 13.3462C13.5044 13.5112 13.3244 13.6463 13.1444 13.6463H11.8701V14.6956C11.8701 14.8706 11.7457 15.005 11.5707 15.005C11.3507 15.005 11.2163 14.8706 11.2163 14.6956V11.8569C11.2163 11.6775 11.3513 11.5469 11.5707 11.5469H13.3251C13.5451 11.5469 13.6751 11.6775 13.6751 11.8569C13.6751 12.0169 13.5451 12.1969 13.3251 12.1969H11.8701V12.1975Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.625 16.875H3.75V17.5H15.625C15.9688 17.5 16.25 17.2188 16.25 16.875V16.25C16.25 16.5938 15.9688 16.875 15.625 16.875Z",
    fill: "#CAD1D8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/Pdf.203aac61d4b3cadf35702f2a2d24098f.svg";
export { ForwardRef as ReactComponent };